var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "site header", attrs: { role: "banner" } },
    [
      _c("div", { staticClass: "ux container" }, [
        _c(
          "div",
          { staticClass: "logo section" },
          [
            _c("content-item", {
              staticClass: "d-inline-block mt-3",
              attrs: { "bundle-name": "Header", "item-key": "LOGO_LEFT" }
            }),
            _vm._v(" "),
            _c("content-item", {
              staticClass: "float-right mt-5",
              attrs: { "bundle-name": "Header", "item-key": "LOGO_RIGHT" }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-041d2fee", { render: render, staticRenderFns: staticRenderFns })
  }
}